export default "__VITE_ASSET__BVs8d0Uu__"